import { CONTACT, IMG, SITE } from "@/data/content";

// ── 7 dedicated service pages with unique, hand-crafted content ──
export const SERVICE_DETAIL_PAGES = {
    "nettoyage-bureaux-strasbourg": {
        slug: "nettoyage-bureaux-strasbourg",
        metaTitle: "Nettoyage de bureaux à Strasbourg | IGN Services Alsace",
        metaDesc: "Nettoyage professionnel de bureaux à Strasbourg et en Alsace. Entretien régulier, désinfection des postes de travail, sols et sanitaires. Devis gratuit sous 24h.",
        heroImg: "https://static.prod-images.emergentagent.com/jobs/80949cf8-7823-4558-992a-75c4b013c9fa/images/113c7145e25e2c32a2a24a9d7ac0669ffa0cd2a38c377bdc13e0c138447721d3.jpeg",
        kicker: "Nettoyage de bureaux",
        h1: "Nettoyage de bureaux à Strasbourg",
        intro: [
            "Des bureaux propres ne sont pas un luxe — c'est une condition de travail. IGN Services Alsace assure l'entretien professionnel de vos espaces de travail à Strasbourg et dans toute l'Alsace, avec des interventions planifiées selon vos horaires et vos exigences.",
            "Que vous gériez un open space, un cabinet, un coworking ou un siège d'entreprise, nous mettons en place un programme d'entretien adapté à la fréquentation, à la surface et aux spécificités de vos locaux.",
        ],
        sections: [
            {
                title: "Ce que nous prenons en charge",
                items: [
                    "Aspiration et lavage des sols (moquettes, carrelages, parquets)",
                    "Dépoussiérage des surfaces, bureaux, étagères et luminaires",
                    "Nettoyage et désinfection des sanitaires et points d'eau",
                    "Vidage des corbeilles et remplacement des sacs",
                    "Nettoyage des espaces de pause, cuisines et réfectoires",
                    "Désinfection des poignées, interrupteurs et surfaces de contact",
                    "Entretien des vitres intérieures accessibles",
                ],
            },
            {
                title: "Notre méthode",
                text: "Chaque contrat d'entretien de bureaux commence par un audit gratuit de vos locaux. Nous identifions les zones à fort passage, les points critiques (sanitaires, cuisines, salles de réunion) et définissons ensemble la fréquence et les horaires d'intervention. Un interlocuteur unique vous accompagne tout au long de la prestation. Après chaque passage, un contrôle qualité est réalisé pour garantir un résultat constant et irréprochable.",
            },
            {
                title: "À qui s'adresse cette prestation",
                items: [
                    "Entreprises et PME à Strasbourg",
                    "Cabinets d'avocats, comptables, médicaux",
                    "Espaces de coworking et centres d'affaires",
                    "Associations et administrations",
                    "Sièges sociaux et agences",
                ],
            },
        ],
        advantages: ["Intervention hors horaires de bureau", "Interlocuteur unique dédié", "Contrôle qualité systématique", "Produits professionnels certifiés", "Fréquence adaptable (quotidien, hebdomadaire, personnalisé)", "Devis gratuit sous 24h"],
        faq: [
            { q: "Intervenez-vous le soir ou le week-end pour le nettoyage de bureaux ?", a: "Oui, nous adaptons nos horaires d'intervention pour ne pas perturber votre activité. Interventions possibles tôt le matin, en soirée ou le week-end selon vos besoins." },
            { q: "Proposez-vous un contrat d'entretien régulier pour les bureaux ?", a: "Oui, nous proposons des contrats d'entretien hebdomadaire, bi-hebdomadaire ou personnalisé. La fréquence est définie selon la taille de vos locaux et votre activité." },
            { q: "Quels produits utilisez-vous pour le nettoyage de bureaux ?", a: "Nous utilisons exclusivement des solutions professionnelles reconnues, adaptées aux environnements de travail et respectueuses des surfaces traitées." },
            { q: "Combien coûte le nettoyage de bureaux à Strasbourg ?", a: "Le tarif dépend de la surface, de la fréquence et des prestations incluses. Nous établissons un devis gratuit et détaillé après un audit de vos locaux." },
        ],
        relatedPages: [
            { label: "Vitrerie professionnelle", to: "/nettoyage-vitres-strasbourg" },
            { label: "Nettoyage de restaurants", to: "/nettoyage-restaurants-strasbourg" },
            { label: "Remise en état", to: "/remise-en-etat-strasbourg" },
        ],
        serviceType: "Nettoyage de bureaux",
        devisService: "Nettoyage de bureaux",
    },

    "nettoyage-ecoles-strasbourg": {
        slug: "nettoyage-ecoles-strasbourg",
        metaTitle: "Nettoyage d'écoles à Strasbourg | IGN Services Alsace",
        metaDesc: "Nettoyage professionnel d'écoles et établissements scolaires à Strasbourg. Entretien des salles de classe, sanitaires, cantines et espaces communs. Devis gratuit.",
        heroImg: "https://images.unsplash.com/photo-1643199121319-b3b5695e4acb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzY2hvb2wlMjBjbGFzc3Jvb20lMjBjbGVhbiUyMGJyaWdodCUyMGludGVyaW9yfGVufDB8fHx8MTc4NjY2MTk5Nnww&ixlib=rb-4.1.0&q=85",
        kicker: "Nettoyage scolaire",
        h1: "Nettoyage d'écoles à Strasbourg",
        intro: [
            "L'hygiène dans un établissement scolaire n'est pas négociable. IGN Services Alsace propose un entretien professionnel adapté aux écoles, crèches, collèges et lycées à Strasbourg et en Alsace, avec des protocoles pensés pour protéger la santé des enfants et du personnel.",
            "Nous intervenons en dehors des heures de cours pour garantir des locaux propres, sains et accueillants chaque matin. Nos équipes sont formées aux exigences spécifiques des environnements accueillant un jeune public.",
        ],
        sections: [
            {
                title: "Nos prestations en milieu scolaire",
                items: [
                    "Nettoyage et désinfection des salles de classe",
                    "Entretien des sanitaires (lavabos, toilettes, distributeurs)",
                    "Nettoyage des cantines et espaces de restauration",
                    "Entretien des couloirs, halls et escaliers",
                    "Désinfection des poignées, rampes et surfaces de contact",
                    "Nettoyage des salles de sport et vestiaires",
                    "Entretien des espaces administratifs et salles des professeurs",
                ],
            },
            {
                title: "Pourquoi un nettoyage professionnel en milieu scolaire",
                text: "Les établissements scolaires sont des lieux de passage intense où les risques de transmission sont élevés. Un nettoyage professionnel régulier, avec des produits adaptés et des protocoles de désinfection ciblés, permet de réduire significativement la propagation des virus et bactéries. IGN Services Alsace applique des méthodes éprouvées dans des environnements exigeants, en accordant une attention particulière aux surfaces de contact fréquent.",
            },
            {
                title: "Établissements concernés",
                items: [
                    "Écoles maternelles et élémentaires",
                    "Crèches et haltes-garderies",
                    "Collèges et lycées",
                    "Centres de formation et universités",
                    "Centres de loisirs et périscolaires",
                ],
            },
        ],
        advantages: ["Intervention hors heures de cours", "Produits adaptés au jeune public", "Protocoles de désinfection renforcés", "Personnel formé aux environnements scolaires", "Fréquence adaptable", "Suivi et contrôle qualité"],
        faq: [
            { q: "Intervenez-vous pendant les vacances scolaires ?", a: "Oui, les vacances scolaires sont un moment idéal pour réaliser un nettoyage en profondeur des établissements. Nous proposons des interventions ponctuelles ou complètes pendant ces périodes." },
            { q: "Vos produits sont-ils adaptés aux enfants ?", a: "Oui, nous sélectionnons des solutions professionnelles adaptées aux environnements accueillant un jeune public, en privilégiant l'efficacité tout en respectant les normes en vigueur." },
            { q: "Pouvez-vous intervenir dans une cantine scolaire ?", a: "Oui, nous entretenons les espaces de restauration scolaire en respectant les standards d'hygiène alimentaire et les bonnes pratiques HACCP." },
            { q: "Quelle est la fréquence recommandée ?", a: "Pour un établissement scolaire, nous recommandons un entretien quotidien des sanitaires et zones de passage, et un nettoyage approfondi hebdomadaire ou bimensuel selon la taille de l'établissement." },
        ],
        relatedPages: [
            { label: "Nettoyage de bureaux", to: "/nettoyage-bureaux-strasbourg" },
            { label: "Désinfection professionnelle", to: "/nettoyage-fin-chantier-strasbourg" },
            { label: "Vitrerie professionnelle", to: "/nettoyage-vitres-strasbourg" },
        ],
        serviceType: "Nettoyage d'écoles",
        devisService: "Nettoyage d'écoles et établissements scolaires",
    },

    "nettoyage-restaurants-strasbourg": {
        slug: "nettoyage-restaurants-strasbourg",
        metaTitle: "Nettoyage de restaurants à Strasbourg | IGN Services Alsace",
        metaDesc: "Nettoyage professionnel de restaurants à Strasbourg et en Alsace. Dégraissage cuisine, entretien salle, normes HACCP. Ancien responsable hygiène restauration. Devis gratuit.",
        heroImg: "https://static.prod-images.emergentagent.com/jobs/80949cf8-7823-4558-992a-75c4b013c9fa/images/11bd7b45a5486e57e30390e619085bbb454ce98db76be0318a3c2a21714a6d33.jpeg",
        kicker: "Nettoyage restauration",
        h1: "Nettoyage de restaurants à Strasbourg",
        intro: [
            "Le nettoyage d'un restaurant ne s'improvise pas. Ancien directeur de restaurant et responsable hygiène, le fondateur d'IGN Services Alsace connaît les exigences du secteur de l'intérieur. Nous intervenons à Strasbourg et en Alsace pour l'entretien régulier et le nettoyage en profondeur de vos établissements de restauration.",
            "De la cuisine à la salle, des sanitaires aux terrasses, chaque zone est traitée avec des protocoles adaptés aux standards d'hygiène alimentaire. Notre expertise terrain fait la différence : nous ne nettoyons pas un restaurant comme un bureau.",
        ],
        sections: [
            {
                title: "Nos prestations en restauration",
                items: [
                    "Dégraissage en profondeur des cuisines professionnelles",
                    "Nettoyage des hottes, filtres et conduits accessibles",
                    "Entretien des sols (carrelage, résine, antidérapant)",
                    "Nettoyage et désinfection des plans de travail et surfaces inox",
                    "Entretien de la salle, du mobilier et des vitrages",
                    "Nettoyage des sanitaires clients et personnel",
                    "Entretien des terrasses et espaces extérieurs accessibles",
                ],
            },
            {
                title: "L'expertise d'un ancien responsable hygiène",
                text: "Notre fondateur a dirigé des restaurants et supervisé des audits hygiène avec des notes de 100/100. Cette expérience terrain se retrouve dans chaque intervention : nous comprenons les contraintes du service, les zones critiques d'un établissement et les exigences des contrôles sanitaires. Nous ne nous contentons pas de nettoyer — nous vous aidons à maintenir un niveau d'hygiène irréprochable au quotidien.",
            },
            {
                title: "Établissements accompagnés",
                items: [
                    "Restaurants traditionnels et gastronomiques",
                    "Brasseries et winstubs alsaciennes",
                    "Restauration rapide et snacking",
                    "Hôtels-restaurants",
                    "Traiteurs et laboratoires de production",
                    "Boulangeries-pâtisseries avec espace restauration",
                ],
            },
        ],
        advantages: ["Ancien responsable hygiène restauration", "Connaissance des standards HACCP", "Dégraissage cuisine en profondeur", "Intervention hors heures de service", "Protocoles adaptés au secteur alimentaire", "Contrôle qualité après chaque passage"],
        faq: [
            { q: "Intervenez-vous la nuit pour les restaurants ?", a: "Oui, nous intervenons régulièrement en dehors des heures de service — en soirée tardive, la nuit ou tôt le matin — pour ne pas perturber votre activité." },
            { q: "Connaissez-vous les normes HACCP ?", a: "Oui, notre fondateur a été responsable hygiène en restauration avec des audits à 100/100. Nos protocoles intègrent les bonnes pratiques d'hygiène alimentaire." },
            { q: "Pouvez-vous dégraisser une cuisine professionnelle ?", a: "Oui, le dégraissage en profondeur est l'une de nos spécialités : hottes, filtres, plans de travail inox, sols, murs et équipements accessibles." },
            { q: "Proposez-vous un entretien régulier pour les restaurants ?", a: "Oui, nous mettons en place un programme d'entretien adapté à votre activité : quotidien pour les zones critiques, hebdomadaire pour le nettoyage approfondi." },
        ],
        relatedPages: [
            { label: "Nettoyage de vitres", to: "/nettoyage-vitres-strasbourg" },
            { label: "Nettoyage de bureaux", to: "/nettoyage-bureaux-strasbourg" },
            { label: "Remise en état", to: "/remise-en-etat-strasbourg" },
        ],
        serviceType: "Nettoyage de restaurants",
        devisService: "Nettoyage de restaurants",
    },

    "nettoyage-vitres-strasbourg": {
        slug: "nettoyage-vitres-strasbourg",
        metaTitle: "Nettoyage de vitres à Strasbourg | IGN Services Alsace",
        metaDesc: "Nettoyage de vitres professionnel à Strasbourg et en Alsace. Vitrerie intérieure et extérieure, baies vitrées, vitrines de commerces. Résultat sans traces. Devis gratuit.",
        heroImg: "https://static.prod-images.emergentagent.com/jobs/80949cf8-7823-4558-992a-75c4b013c9fa/images/28a2d654ed01c3a986ed9c6a4e325f563fd07aeb2759ffe1628bbd024d603d68.jpeg",
        kicker: "Vitrerie professionnelle",
        h1: "Nettoyage de vitres à Strasbourg",
        intro: [
            "Des vitres propres transforment un espace. IGN Services Alsace assure le nettoyage professionnel de toutes vos surfaces vitrées à Strasbourg et en Alsace : vitrines, baies vitrées, fenêtres, vérandas et cloisons vitrées, avec un résultat sans traces et une transparence parfaite.",
            "Nous intervenons pour les professionnels (commerces, bureaux, restaurants, copropriétés) comme pour les particuliers. Chaque prestation utilise des techniques et des produits professionnels adaptés au type de vitrage et à son accessibilité.",
        ],
        sections: [
            {
                title: "Nos prestations de vitrerie",
                items: [
                    "Nettoyage de vitres intérieures et extérieures",
                    "Entretien des baies vitrées et grandes surfaces vitrées",
                    "Nettoyage de vitrines de commerces",
                    "Entretien des cloisons vitrées de bureaux",
                    "Nettoyage de vérandas et verrières",
                    "Nettoyage des encadrements et appuis de fenêtres",
                    "Traitement des traces de calcaire et de pollution",
                ],
            },
            {
                title: "Notre méthode",
                text: "Nous utilisons des raclettes professionnelles, des mouilleurs adaptés et des solutions de nettoyage spécifiques qui ne laissent aucune trace ni résidu. Pour les surfaces difficiles d'accès, nous employons des perches télescopiques permettant un travail en sécurité. Chaque intervention se conclut par un contrôle visuel minutieux pour garantir un résultat impeccable.",
            },
            {
                title: "Pour qui",
                items: [
                    "Commerces et boutiques (vitrines)",
                    "Bureaux et espaces de coworking",
                    "Restaurants et hôtels",
                    "Copropriétés (parties communes vitrées)",
                    "Particuliers (maisons, vérandas)",
                ],
            },
        ],
        advantages: ["Résultat sans traces garanti", "Techniques professionnelles", "Perches télescopiques pour l'accès en hauteur", "Intervention régulière ou ponctuelle", "Encadrements et appuis inclus", "Devis gratuit sous 24h"],
        faq: [
            { q: "Nettoyez-vous les vitres en hauteur ?", a: "Oui, nous utilisons des perches télescopiques professionnelles pour atteindre les vitres en hauteur en toute sécurité, sans échelle ni nacelle pour les hauteurs accessibles." },
            { q: "Quelle est la fréquence recommandée pour les vitrines de commerce ?", a: "Pour les commerces, nous recommandons un nettoyage hebdomadaire ou bimensuel des vitrines afin de conserver une image impeccable en permanence." },
            { q: "Intervenez-vous chez les particuliers ?", a: "Oui, nous proposons le nettoyage de vitres pour les particuliers : maisons, appartements, vérandas et baies vitrées." },
            { q: "Les encadrements sont-ils compris dans la prestation ?", a: "Oui, le nettoyage des encadrements, appuis de fenêtres et rails fait partie de notre prestation standard de vitrerie." },
        ],
        relatedPages: [
            { label: "Nettoyage de bureaux", to: "/nettoyage-bureaux-strasbourg" },
            { label: "Nettoyage de restaurants", to: "/nettoyage-restaurants-strasbourg" },
            { label: "Entrepôts et logistique", to: "/nettoyage-entrepots-alsace" },
        ],
        serviceType: "Nettoyage de vitres",
        devisService: "Nettoyage de vitres / Vitrerie",
    },

    "nettoyage-fin-chantier-strasbourg": {
        slug: "nettoyage-fin-chantier-strasbourg",
        metaTitle: "Nettoyage fin de chantier à Strasbourg | IGN Services Alsace",
        metaDesc: "Nettoyage de fin de chantier à Strasbourg et en Alsace. Dépoussiérage, lavage des sols, nettoyage des vitres et surfaces après travaux. Livraison propre garantie. Devis gratuit.",
        heroImg: "https://static.prod-images.emergentagent.com/jobs/80949cf8-7823-4558-992a-75c4b013c9fa/images/2e6d7a2fbb558136729300333f682222d93c0aa32ebc0b775201e4942d37f0b0.jpeg",
        kicker: "Fin de chantier",
        h1: "Nettoyage de fin de chantier à Strasbourg",
        intro: [
            "Un chantier terminé n'est pas un chantier livré — pas tant que les lieux ne sont pas parfaitement propres. IGN Services Alsace réalise le nettoyage complet de fin de chantier à Strasbourg et en Alsace, pour livrer des espaces impeccables, prêts à être utilisés ou remis au client.",
            "Que vous soyez artisan, entreprise du BTP, promoteur immobilier ou particulier ayant réalisé des travaux, nous intervenons après la fin des travaux pour éliminer toutes les traces de poussière, résidus et salissures laissées par le chantier.",
        ],
        sections: [
            {
                title: "Ce que comprend notre intervention",
                items: [
                    "Dépoussiérage complet de toutes les surfaces (murs, plafonds, luminaires)",
                    "Aspiration et lavage des sols (carrelage, parquet, béton, résine)",
                    "Nettoyage des vitres, encadrements et appuis",
                    "Nettoyage des sanitaires, robinetterie et éviers neufs",
                    "Retrait des étiquettes, films de protection et résidus de colle",
                    "Nettoyage des prises, interrupteurs et poignées",
                    "Évacuation des résidus légers et poussières de chantier",
                ],
            },
            {
                title: "Notre méthode de nettoyage après travaux",
                text: "Le nettoyage de fin de chantier demande une méthodologie rigoureuse. Nous procédons de haut en bas et de l'intérieur vers l'extérieur pour éviter toute recontamination. Chaque pièce est traitée méthodiquement : dépoussiérage des surfaces hautes, nettoyage des menuiseries et vitrages, puis finition des sols. Le résultat est contrôlé pièce par pièce avant validation.",
            },
            {
                title: "Pour qui",
                items: [
                    "Artisans et entreprises du bâtiment",
                    "Promoteurs immobiliers et constructeurs",
                    "Architectes et maîtres d'œuvre",
                    "Particuliers ayant réalisé des travaux",
                    "Syndics et gestionnaires de copropriétés",
                ],
            },
        ],
        advantages: ["Livraison propre et prête à l'emploi", "Méthodologie haut en bas", "Nettoyage des vitres inclus", "Retrait des films et étiquettes", "Contrôle qualité pièce par pièce", "Intervention rapide après fin de chantier"],
        faq: [
            { q: "Quand pouvez-vous intervenir après la fin des travaux ?", a: "Nous pouvons intervenir dès la fin effective du chantier, généralement sous 24 à 48h après votre demande. Pour les chantiers planifiés, nous réservons les créneaux en amont." },
            { q: "Le nettoyage de fin de chantier inclut-il les vitres ?", a: "Oui, le nettoyage des vitres, encadrements et appuis fait partie de notre prestation standard de fin de chantier." },
            { q: "Intervenez-vous sur des chantiers de grande taille ?", a: "Oui, nous intervenons aussi bien sur des petits chantiers de rénovation que sur des chantiers de construction neuve de grande envergure." },
            { q: "Évacuez-vous les gravats et déchets de chantier ?", a: "Nous évacuons les résidus légers et poussières. L'évacuation des gravats et déchets lourds de chantier n'est pas incluse et relève de l'entreprise de BTP." },
        ],
        relatedPages: [
            { label: "Remise en état", to: "/remise-en-etat-strasbourg" },
            { label: "Nettoyage de bureaux", to: "/nettoyage-bureaux-strasbourg" },
            { label: "Nettoyage de vitres", to: "/nettoyage-vitres-strasbourg" },
        ],
        serviceType: "Nettoyage de fin de chantier",
        devisService: "Nettoyage de fin de chantier",
    },

    "remise-en-etat-strasbourg": {
        slug: "remise-en-etat-strasbourg",
        metaTitle: "Remise en état à Strasbourg | IGN Services Alsace",
        metaDesc: "Remise en état professionnelle à Strasbourg et en Alsace. Après sinistre, déménagement, dégradation ou inoccupation. Nettoyage en profondeur, résultat impeccable. Devis gratuit.",
        heroImg: "https://images.unsplash.com/photo-1758448018619-4cbe2250b9ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiYXRocm9vbSUyMHNwb3RsZXNzJTIwbWFyYmxlfGVufDB8fHx8MTc3NTI0NTA0NHww&ixlib=rb-4.1.0&q=85",
        kicker: "Remise en état",
        h1: "Remise en état à Strasbourg",
        intro: [
            "Votre logement ou vos locaux nécessitent une remise en propreté complète ? IGN Services Alsace réalise la remise en état professionnelle de vos espaces à Strasbourg et en Alsace : après un déménagement, un sinistre, des travaux, une longue inoccupation ou une dégradation.",
            "Notre objectif est simple : redonner de la valeur à vos lieux. Nous traitons chaque pièce méthodiquement pour un résultat visible et durable, quelle que soit la situation initiale.",
        ],
        sections: [
            {
                title: "Ce que comprend la remise en état",
                items: [
                    "Nettoyage en profondeur de toutes les surfaces (sols, murs, plafonds)",
                    "Décrassage et dégraissage des cuisines et équipements",
                    "Nettoyage et désinfection des sanitaires",
                    "Nettoyage des vitres, encadrements et volets accessibles",
                    "Traitement des traces, taches et résidus incrustés",
                    "Désodorisation si nécessaire",
                    "Remise en propreté des espaces de rangement et placards",
                ],
            },
            {
                title: "Les situations que nous traitons",
                text: "Chaque remise en état est différente. Nous intervenons après un déménagement pour remettre un logement en état de location ou de vente, après un sinistre (dégât des eaux, incendie léger) pour restaurer la propreté, après une longue période d'inoccupation pour supprimer poussière et moisissures, ou encore après une dégradation pour remettre les lieux dans un état acceptable. Nous évaluons systématiquement la situation avant de proposer un plan d'intervention adapté.",
            },
            {
                title: "Pour qui",
                items: [
                    "Propriétaires bailleurs (entre deux locataires)",
                    "Agences immobilières et gestionnaires",
                    "Particuliers (vente ou emménagement)",
                    "Syndics de copropriété",
                    "Assureurs (après sinistre)",
                    "Entreprises (changement de locaux)",
                ],
            },
        ],
        advantages: ["Évaluation gratuite de la situation", "Plan d'intervention adapté", "Nettoyage en profondeur méthodique", "Désodorisation incluse si nécessaire", "Résultat prêt à habiter ou à louer", "Devis détaillé sous 24h"],
        faq: [
            { q: "Quelle est la différence entre remise en état et nettoyage classique ?", a: "La remise en état est un nettoyage en profondeur destiné à restaurer un espace dégradé ou fortement sali. Elle va bien au-delà de l'entretien courant : décrassage, traitement des taches, désodorisation, etc." },
            { q: "Intervenez-vous après un dégât des eaux ?", a: "Oui, nous intervenons après un dégât des eaux pour nettoyer, sécher et remettre en état les surfaces touchées, en complément des travaux de réparation." },
            { q: "Pouvez-vous intervenir avant un état des lieux ?", a: "Oui, c'est l'un de nos cas les plus fréquents. Nous remettons le logement en état de propreté pour un état des lieux réussi." },
            { q: "Combien coûte une remise en état à Strasbourg ?", a: "Le tarif dépend de la surface, de l'état des lieux et des prestations nécessaires. Un devis gratuit et détaillé est établi après évaluation." },
        ],
        relatedPages: [
            { label: "Nettoyage fin de chantier", to: "/nettoyage-fin-chantier-strasbourg" },
            { label: "Syndrome de Diogène", to: "/nettoyage-syndrome-diogene-strasbourg" },
            { label: "Nettoyage après décès", to: "/nettoyage-apres-deces-strasbourg" },
        ],
        serviceType: "Remise en état",
        devisService: "Remise en état",
    },

    "nettoyage-entrepots-alsace": {
        slug: "nettoyage-entrepots-alsace",
        metaTitle: "Nettoyage d'entrepôts en Alsace | IGN Services Alsace",
        metaDesc: "Nettoyage professionnel d'entrepôts et plateformes logistiques en Alsace. Sols industriels, quais, bureaux, zones de circulation. Devis gratuit sous 24h.",
        heroImg: "https://images.unsplash.com/photo-1771530789155-b1f03fbf82b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMHdhcmVob3VzZSUyMGxvZ2lzdGljcyUyMGluZHVzdHJpYWwlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODY2NjE5OTZ8MA&ixlib=rb-4.1.0&q=85",
        kicker: "Nettoyage logistique",
        h1: "Nettoyage d'entrepôts en Alsace",
        intro: [
            "Les entrepôts et plateformes logistiques ont des exigences spécifiques en matière de propreté : sols industriels à grande surface, quais de chargement, zones de circulation de chariots, bureaux intégrés et espaces sociaux. IGN Services Alsace propose un nettoyage professionnel adapté à ces environnements en Alsace.",
            "Nous intervenons sur site avec des équipements adaptés aux grandes surfaces et aux contraintes logistiques : horaires flexibles, intervention sur zones définies pour ne pas bloquer l'activité, produits compatibles avec les sols industriels.",
        ],
        sections: [
            {
                title: "Nos prestations en entrepôt",
                items: [
                    "Balayage et lavage mécanisé des sols industriels",
                    "Nettoyage des quais de chargement et zones de réception",
                    "Entretien des bureaux et espaces administratifs intégrés",
                    "Nettoyage des sanitaires et vestiaires du personnel",
                    "Entretien des espaces de pause et réfectoires",
                    "Dépoussiérage des structures, racks et éclairages accessibles",
                    "Nettoyage des zones de circulation et marquage au sol",
                ],
            },
            {
                title: "Une approche adaptée à la logistique",
                text: "Nous comprenons que l'activité d'un entrepôt ne s'arrête pas pour le nettoyage. C'est pourquoi nous organisons nos interventions par zones, en concertation avec votre responsable de site, pour limiter l'impact sur vos opérations. Nos équipes sont habituées aux environnements logistiques et respectent les consignes de sécurité propres à chaque site.",
            },
            {
                title: "Sites concernés",
                items: [
                    "Entrepôts de stockage et de distribution",
                    "Plateformes logistiques et centres de tri",
                    "Zones d'activité et parcs industriels",
                    "Ateliers de production et de conditionnement",
                    "Bases logistiques de grande distribution",
                ],
            },
        ],
        advantages: ["Intervention par zones pour continuité d'activité", "Équipements adaptés aux grandes surfaces", "Horaires flexibles (nuit, week-end)", "Respect des consignes de sécurité", "Entretien bureaux + entrepôt combiné", "Devis gratuit sous 24h"],
        faq: [
            { q: "Intervenez-vous la nuit dans les entrepôts ?", a: "Oui, nous proposons des interventions de nuit ou le week-end pour les sites logistiques fonctionnant en journée." },
            { q: "Disposez-vous d'équipements pour les grandes surfaces ?", a: "Oui, nous utilisons des auto-laveuses et des balayeuses adaptées aux sols industriels de grande superficie." },
            { q: "Pouvez-vous combiner entrepôt et bureaux attenants ?", a: "Oui, nous proposons une prestation globale couvrant l'entrepôt, les bureaux, les sanitaires et les espaces sociaux." },
            { q: "Intervenez-vous dans les zones d'activité hors Strasbourg ?", a: "Oui, nous intervenons dans toute l'Alsace : Bas-Rhin et Haut-Rhin, notamment dans les zones d'activité de Haguenau, Molsheim, Sélestat, Colmar et Mulhouse." },
        ],
        relatedPages: [
            { label: "Nettoyage de bureaux", to: "/nettoyage-bureaux-strasbourg" },
            { label: "Nettoyage fin de chantier", to: "/nettoyage-fin-chantier-strasbourg" },
            { label: "Remise en état", to: "/remise-en-etat-strasbourg" },
        ],
        serviceType: "Nettoyage d'entrepôts",
        devisService: "Nettoyage d'entrepôts et plateformes logistiques",
    },
};
